export const CALENDAR_SCROLL_INSET_CSS_VAR = '--calendar-scroll-inset-right';

export const CALENDAR_SCROLL_INSET_WITH_OVERFLOW = '8px';
export const CALENDAR_SCROLL_INSET_WITHOUT_OVERFLOW = '0px';

export const CALENDAR_SCROLL_INSET_VALUE = `var(${CALENDAR_SCROLL_INSET_CSS_VAR}, ${CALENDAR_SCROLL_INSET_WITH_OVERFLOW})`;

export const CALENDAR_GRID_WIDTH_COMPENSATION = `calc(100% + ${CALENDAR_SCROLL_INSET_VALUE})`;

export const CALENDAR_SCROLLBAR_TRACK_PADDING = 10;
